import React, { FunctionComponent } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";

interface ReviewBoxItem {
  label: string;
  value: string;
  optional?: boolean;
  hideLabel?: boolean;
}

interface ReviewBoxProps {
  goToPage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  items:
    | { [key: string]: { title: string; items: ReviewBoxItem[] } }
    | ReviewBoxItem[];
  title: string;
}

const ReviewBox: FunctionComponent<ReviewBoxProps> = ({
  goToPage,
  items,
  title,
}) => {
  const t = useTranslate();

  const renderItems = (items: ReviewBoxItem[]): JSX.Element => {
    return (
      <ul role="list">
        {items.map(item => (
          <li key={item.label} role="listitem">
            <p>
              {!item.hideLabel && item.label}
              {` ${item.optional ? t("enroll_form.optional") : ""}`}
            </p>
            <p>{item.value || t("enroll_form.review.chose_not_to_answer")}</p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="EnrollmentFormPage__reviewBox">
      <div className="ds-u-padding--2 ds-u-border-bottom--2 ds-u-border-color--gray ds-u-display--flex ds-u-justify-content--between ds-u-align-items--center">
        <h2 className="ds-h3 ds-u-margin--0">{title}</h2>
        <Button
          variation="transparent"
          className="ds-u-text-transform--capitalize ds-c-button--primary-alt ds-u-padding--0 ds-u-margin-left--1"
          onClick={goToPage}
          aria-label={`${t("edit")} ${title}`}
        >
          {t("edit")}
        </Button>
      </div>
      {Array.isArray(items)
        ? renderItems(items)
        : Object.keys(items).map(key => (
            <>
              <h3 className="ds-u-margin-left--3">{items[key].title}</h3>
              {renderItems(items[key].items)}
            </>
          ))}
    </div>
  );
};

export default ReviewBox;
